import { JsonConvert, JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse } from "../base-response";
import { AntennaModelEnum, AntennaModelEnumConverter } from "../enum/antenna-model.enum";
import { TypeEnum, TypeEnumConverter } from "../enum/type.enum";
import { LongitudinalLoss, LongitudinalLossConverter } from "./longitudinal-loss";
import { CouplingLoss, CouplingLossConverter } from "./coupling-loss";
import { Tilt, TiltConverter } from "./tilt";
import { TerminationOmni, TerminationOmniConverter } from "./termination-omni";

@JsonConverter
export class AntennaListConverter implements JsonCustomConvert<AntennaList> {
  serialize() { }
  deserialize(data: any): AntennaList {
    const antenna = new AntennaList();
    antenna.antennaId = data?.antennaId ?? "";
    antenna.name = data?.name ?? "";
    antenna.model = new AntennaModelEnumConverter().deserialize(data?.model);
    antenna.length = Number(data?.length ?? data?.lenght ?? 0);
    antenna.type = new TypeEnumConverter().deserialize(data?.type);
    antenna.longitudinalLoss = new LongitudinalLossConverter().deserialize(data?.longitudinalLoss ?? {});
    antenna.couplingLoss = new CouplingLossConverter().deserialize(data?.couplingLoss ?? {});
    antenna.tilt = new TiltConverter().deserialize(data?.tilt ?? {});
    antenna.terminationOmni = new TerminationOmniConverter().deserialize(data?.terminationOmni ?? {});
    antenna.enabled = Boolean(data?.enabled);
    return antenna;
  }
}

@JsonConverter
export class AntennaListArrayConverter implements JsonCustomConvert<Array<AntennaList>> {
    serialize() { }
    deserialize(data: any): Array<AntennaList> {
      const converter = new AntennaListConverter();
      return (data ?? []).map((item: any) => converter.deserialize(item));
    }
}

@JsonConverter
export class AntennaListListConverter implements JsonCustomConvert<AntennaCountList> {
    serialize() { }
    deserialize(data: any): AntennaCountList {
      const list = new AntennaCountList();
      list.count = Number(data?.count ?? 0);
      list.items = new AntennaListArrayConverter().deserialize(data?.items ?? data?.data ?? []);
      return list;
    }
}

@JsonObject("AntennaList")
export class AntennaList {
    @JsonProperty("antennaId", String, true)
    antennaId: string = "";
    @JsonProperty("name", String, true)
    name: string = "";
    @JsonProperty("model", AntennaModelEnumConverter, true)
    model: AntennaModelEnum = AntennaModelEnum.ANT2;
    @JsonProperty("length", Number, true)
    length: number = 0;
    @JsonProperty("type", TypeEnumConverter, true)
    type: TypeEnum = TypeEnum.TYPE_L;
    @JsonProperty("longitudinalLoss", LongitudinalLossConverter, true)
    longitudinalLoss: LongitudinalLoss = new LongitudinalLoss();
    @JsonProperty("couplingLoss", CouplingLossConverter, true)
    couplingLoss: CouplingLoss = new CouplingLoss();
    @JsonProperty("tilt", TiltConverter, true)
    tilt: Tilt = new Tilt();
    @JsonProperty("terminationOmni", TerminationOmniConverter, true)
    terminationOmni: TerminationOmni = new TerminationOmni();
    @JsonProperty("enabled", Boolean, true)
    enabled: boolean = false;
}

@JsonObject("AntennaCountList")
export class AntennaCountList {
    @JsonProperty("count", Number, true)
    count: number = 0;
    items: Array<AntennaList> = [];
}

@JsonObject("AntennaListData")
export class AntennaListData extends BaseResponse {
    @JsonProperty("data", AntennaListConverter, true)
    data: AntennaList = new AntennaList();
}

@JsonObject("AntennaListDataArray")
export class AntennaListDataArray extends BaseResponse {
    @JsonProperty("data", AntennaListListConverter, true)
    data: AntennaCountList = new AntennaCountList();
} 
